import { BasisType, Goal, Service, Partner } from "@raskrask-dk/raskrask-utils";
import type {IBookableSchedulesDTO} from "..";
import type {ISchedules} from "../assembler/bookable.interface";
import {GoalMapper} from "./GoalMapper";
import {defaultMappers, DomainClasses, MapById} from "./mapper.types";
import {PackageMapper} from "./PackageMapper";
import {PartnerMapper} from "./PartnerMapper";
import {ServiceMapper} from "./ServiceMapper";

export class Mapper {
  private goalMapper: GoalMapper;
  private serviceMapper: ServiceMapper;
  private partnerMapper: PartnerMapper;
  private packageMapper: PackageMapper;

  constructor(constructors: DomainClasses = defaultMappers) {
    const {goal, service, partner, packageTemplate} = constructors;
    this.goalMapper = new GoalMapper(goal);
    this.packageMapper = new PackageMapper(packageTemplate);
    this.serviceMapper = new ServiceMapper(service, this.packageMapper);
    this.partnerMapper = new PartnerMapper(partner);
  }

  fromNormalized(
    schedules: IBookableSchedulesDTO,
    basisType: BasisType
  ): {goals: MapById<Goal>; services: MapById<Service>; partners: MapById<Partner>} {
    const goals = this.goalMapper.fromNormalized(schedules.goals, basisType);
    const services = this.serviceMapper.fromNormalized(schedules.services);
    const partners = this.partnerMapper.fromNormalized(schedules.partners);
    return {
      goals: goals,
      services: services,
      partners: partners,
    };
  }

  fromMaps({goals, services, partners}: {goals: MapById<Goal>; services: MapById<Service>; partners: MapById<Partner>}): ISchedules {
    return {
      goals: Array.from(goals.values()),
      services: Array.from(services.values()),
      partners: Array.from(partners.values()),
    };
  }
}
